import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(axios)
Vue.use(VueAxios)

export default {
  install(Vue) {
    Vue.prototype.$eventRegistrationApiService = {
      event_registration_api_url: `${process.env.VUE_APP_MEMBER_API_URL}/event-registrations`,
      event_registration_api_token: process.env.VUE_APP_MEMBER_API_TOKEN,
      
      /**
       * 建立活動報名資料
       * @param {*} data 
       * @returns 
       */
      async create(data) {
        const response = await axios.post(
          `${this.event_registration_api_url}`,
          data,
          { headers: { 'Authorization': `Bearer ${this.event_registration_api_token}` } }
        )
        
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null;
      }
    }
  }
}
